module.exports = __webpack_public_path__ + "img/steeringAngleHor-bottomNeedle.b3b303b3.svg";